import { Formik, Form } from "formik";
import { Col, Row } from "react-bootstrap";
import * as Yup from "yup";
import { initFilter, TScienceCouncilFilter } from "../models/ScienceCouncilManagerModels";
import { TextFieldCustom } from "../../../category-personnel/components/text-field-custom/TextFieldCustom";
import { generateYears } from "../../../utils/AppFunction";
import { useContext, useEffect, useState } from "react";
import { searchBatchOfRegistration } from "../services/services";
import { CODE, DEFAULT_PAGE_INDEX, MAX_PAGE_SIZE } from "../../../utils/Constant";
import { toast } from "react-toastify";
import { ScienceCouncilContext } from "../ScienceCouncilManagerContext";
import moment from "moment";
import AutocompleteObjectV2 from '../../../component/AutocompleteObjectV2';

export default function Filter() {

  const validationSchema = Yup.object({});
  const { filter, setFilter } = useContext<any>(ScienceCouncilContext);

  const [batchOfRegistrationList, setBatchOfRegistrationList] = useState<any[]>([]);

  useEffect(() => {
    getBatchOfRegistrationList();
  }, [])

  const getBatchOfRegistrationList = async () => {
    try {
      let { data } = await searchBatchOfRegistration({
        pageIndex: DEFAULT_PAGE_INDEX,
        pageSize: MAX_PAGE_SIZE
      });
      if (data?.code === CODE.SUCCESS) {
        setBatchOfRegistrationList(
          data?.data?.content?.map((item: any) => {
            return {
              ...item,
              title: item?.startDate ? moment(item?.startDate).format("DD/MM/YYYY") : "",
              value: item?.id,
            };
          })
        );
      } else {
        toast.error("Đã có lỗi xảy ra!");
      }
    } catch (error) {
      console.error(error);
    }
  }

  const handleSubmit = async (values: TScienceCouncilFilter) => {
    setFilter({...filter, ...values});
  };

  return (
    <Formik
      enableReinitialize
      initialValues={initFilter}
      validationSchema={validationSchema}
      onSubmit={handleSubmit}
    >
      {({
        values,
        touched,
        errors,
        handleChange,
        handleSubmit,
        setFieldValue,
      }) => (
        <Form onSubmit={handleSubmit}>
          <div className="spaces px-10 py-10 bg-white">
            <Row>
              <Col xs={3}>
                <div className="flex align-items-center">
                  <div className="label pe-4 fw-bold">Năm</div>
                  <div className="flex-1">
                    <AutocompleteObjectV2
                      options={generateYears()}
                      isSearchDefauilt={true}
                      name={"yearOption"}
                      onChange={(e: any) =>  {
                        setFieldValue("year", e?.id || null);
                        setFieldValue("yearOption", e);
                      }}
                      value={values.yearOption || generateYears()?.[0]}
                      errors={errors.year}
                      searchObject={{}}
                      getOptionLabel={(e: any) => e?.title}
                    />
                  </div>
                </div>
              </Col>
              <Col xs={3}>
                <div className="flex align-items-center">
                  <div className="label pe-4 fw-bold">Đợt</div>
                  <div className="flex-1">
                    <AutocompleteObjectV2
                      options={[]}
                      isSearchDefauilt={true}
                      name={"regisPeriod"}
                      onChange={(e: any) =>  { setFieldValue("regisPeriodId", e?.id || null) }}
                      searchFunction={() =>
                        searchBatchOfRegistration({
                          pageIndex: DEFAULT_PAGE_INDEX,
                          pageSize: MAX_PAGE_SIZE
                        })
                      }
                      value={values.regisPeriod}
                      errors={errors.regisPeriodId}
                      searchObject={{}}
                      getOptionLabel={(e: any) => e?.startDate ? moment(e?.startDate).format("DD/MM/YYYY") : ""}
                    />
                  </div>
                </div>
              </Col>
              <Col xs={3}>
                <div className="flex align-items-center">
                  <div className="label pe-4 fw-bold">Từ khóa</div>
                  <div className="flex-1">
                    <TextFieldCustom
                      type="text"
                      title=""
                      name="keyword"
                      placeholder="Nhập tên hội đồng"
                      values={values?.keyword}
                      errors={""}
                      handleChange={handleChange}
                    />
                  </div>
                </div>
              </Col>
              <Col xs={1} className="flex align-items-stretch">
                <button
                  type="submit"
                  onClick={() => {}}
                  className="btn-outline btn-filter"
                >
                  <i className="bi bi-filter text-pri fs-3"></i>
                  Lọc
                </button>
              </Col>
            </Row>
          </div>
        </Form>
      )}
    </Formik>
  );
}
